
import React, { SVGProps } from 'react';

const SvgCreateAlerts = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none" {...props}>
            <g clip-path="url(#clip0_6196_381)">
                <path d="M7.7952 16.6252C8.38279 17.1179 9.15471 17.4168 10 17.4168C10.8455 17.4168 11.6173 17.1179 12.2049 16.6252M15 6.3335V1.5835M12.5 3.9585H17.5M10.8334 1.64991C10.5598 1.60599 10.2811 1.5835 10 1.5835C8.67396 1.5835 7.40221 2.08394 6.46453 2.97474C5.52684 3.86554 5.00006 5.07372 5.00006 6.3335C5.00006 8.7799 4.35045 10.4549 3.62478 11.5628C3.01267 12.4973 2.70661 12.9646 2.71783 13.095C2.73026 13.2393 2.76244 13.2943 2.88487 13.3806C2.99544 13.4585 3.49388 13.4585 4.49077 13.4585H15.5094C16.5062 13.4585 17.0046 13.4585 17.1152 13.3806C17.2376 13.2943 17.2698 13.2393 17.2822 13.095C17.2935 12.9646 16.9874 12.4973 16.3752 11.5626C15.9652 10.9366 15.5795 10.1294 15.3215 9.10433" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_6196_381">
                    <rect width="20" height="19" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default SvgCreateAlerts;
